import React from 'react';

import { adalConfig, authContext } from '../adalConfig';

interface CustomInputProps {
  error?: string;
}

const ErrorPage: React.FC<CustomInputProps> = (props: any) => {

  const logout = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    authContext.clearCache();
    window.location.replace(`https://login.microsoftonline.com/${adalConfig.tenant}/oauth2/logout?post_logout_redirect_uri=${adalConfig.postLogoutRedirectUri}`);
  };

  return (
    <div className="ws-welcome">
      <div className="eg-login">
        <div className="box">
          <h1 className="title is-4">
            Sorry, request failed!
          </h1>

          <div>
            {JSON.stringify(props.error)}
            Error was logged with following ID:<br />
            0190344c-21ec-7aa2-b848-5af7f3b7ba51
          </div>

          <br />
          <b>Please contact system administrator for more details.</b>
          <br />
          <br />
          <button className="button is-medium" onClick={logout}>Logout</button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
